export default "__VITE_ASSET__BlSSowbI__"